import { useTranslation } from "react-i18next";
import type { FaqContent } from "src/api/faq";
import { GuideContentsLink } from "src/components/Guide/GuideContentsLink";
import { useSlot } from "src/components/Slots/SlotsContext";

interface GuideContentsProps {
	sections: FaqContent[];
	selectedId?: number;
	onSelect?: () => void;
}

export const GuideContents = ({
	sections,
	selectedId,
	onSelect,
}: GuideContentsProps) => {
	const { t } = useTranslation();
	const AdminContents = useSlot("guideContents");

	const renderLink = (section: FaqContent, index: number) => (
		<GuideContentsLink
			section={section}
			index={index}
			isSelected={section.id === selectedId}
			onSelect={onSelect}
		/>
	);

	const list = (
		<ul className="list-type-none m-0 p-0 flex flex-col">
			{sections.map((section, index) => (
				<li key={section.id}>{renderLink(section, index)}</li>
			))}
		</ul>
	);

	return (
		<nav
			className="basic-box contents-box flex flex-col"
			data-test-id="guide-contents"
		>
			<span className="size-16 text-grey contents-box--padded">
				{t("articles.contents", "Spis treści")}
			</span>
			{AdminContents ? (
				<AdminContents sections={sections} renderLink={renderLink}>
					{list}
				</AdminContents>
			) : (
				list
			)}
		</nav>
	);
};
